import { render } from "./AreasTab.vue?vue&type=template&id=5f1381ea&scoped=true"
import script from "./AreasTab.vue?vue&type=script&lang=js"
export * from "./AreasTab.vue?vue&type=script&lang=js"

import "./AreasTab.vue?vue&type=style&index=0&id=5f1381ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1381ea"]])

export default __exports__